import { FaDownload } from 'react-icons/fa'
import { useDownloadQueue } from '../../context/DownloadQueueContext'

export default function DownloadQueueButton() {
  const { items, toggleDrawer, isDrawerOpen } = useDownloadQueue()

  if (isDrawerOpen) return null

  return (
    <button
      type="button"
      onClick={toggleDrawer}
      title="Download queue"
      className="fixed bottom-6 right-6 z-30 w-[52px] h-[52px] rounded-full bg-[#2b364b] text-white border-none shadow-xl cursor-pointer flex items-center justify-center hover:opacity-80 transition-opacity"
    >
      <FaDownload size={18} />
      {items.length > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[20px] h-[20px] px-1 rounded-full bg-red-500 text-white text-xs font-semibold flex items-center justify-center">
          {items.length > 99 ? '99+' : items.length}
        </span>
      )}
    </button>
  )
}
